export enum ReviewFormSource {
  brand_review_source_unknown = "brand_review_source_unknown",
  logged_out_brand_page = "logged_out_brand_page",
  brand_page = "brand_page",
  product_page = "product_page",
  product_page_review_list_cta = "product_page_review_list_cta",
  order_page = "order_page",
  orders_page_top_banner = "orders_page_top_banner",
  orders_page_write_review_cta = "orders_page_write_review_cta",
  orders_page_edit_review_cta = "orders_page_edit_review_cta",
  orders_page_view_review_cta = "orders_page_view_review_cta",
  brand_reviews_page = "brand_reviews_page",
  packaging_slip = "packaging_slip",
  review_brand_email = "review_brand_email",
  review_brand_reminder_email = "review_brand_reminder_email",
  messenger_review_request = "messenger_review_request",
  brand_personal_link = "brand_personal_link",
  return_page_product_review_banner = "return_page_product_review_banner",
  missing_and_damaged_page_brand_review_banner = "missing_and_damaged_page_brand_review_banner",
  reviews_feed_product_list = "reviews_feed_product_list",
  reviews_feed_order_list = "reviews_feed_order_list",
  messenger_context_orders_list = "messenger_context_orders_list",
  messenger_context_order_details = "messenger_context_order_details",
}
